import { gql } from "@apollo/client";

export const GET_ALL_CONTACT_FORMS = gql`
  query {
    getAllContactForms {
      status
      message
      response {
        _id
        name
        email
        status
        subject
        message
        createdAt
      }
    }
  }
`;

export const UPDATE_CONTACT_FORM_STATUS = gql`
  mutation UpdateContactFormStatus($id: String!, $status: String!) {
    updateContactFormStatus(id: $id, status: $status) {
      status
      message
      response {
        _id
        status
        updatedAt
      }
    }
  }
`;


export const DELETE_CONTACT_FORM = gql`
  mutation DeleteContactForm($id: String!) {
    deleteContactForm(id: $id) {
      status
      message
      response {
        _id
      }
    }
  }
`;
